


























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import axios, { axiosM, axiosC, resHandle } from "@/plugins/axios";
import Pagination from "@/components/paginaiton.vue";
@Component({
  components: {
    Pagination
  }
})
export default class ProjectCreateSecondImportComponent extends Vue {
  @Prop()
  private cZu: any;
  // 搜索条件
  private saveModel: "add" | "delete" = "add";
  private filter: any = {};
  private fanweiOptions: any[] = [];
  private ifShowMore: boolean = false;
  // 排序
  private cSortField: string = "创建时间";
  private cSortValue: string = "1";
  // 分页
  private currentPage: any = 1;
  private totalPage: any = 1;
  private totalNum: any = 0;
  private pageSize: any = 10;
  // 选择
  private isIndeterminate: boolean = false;
  private checkAll: boolean = false;
  private selectedMessages: any[] = [];
  // 数据
  private messages: any[] = [];
  /**
   * @description 返回研究分组列表页
   */
  private backToList() {
    this.$emit("cStateChange", "normal");
  }
  /**
   * @description 获得当前可选的全部医院范围
   */
  private getFanwei() {
    const params: any = {
      params: {
        project_id: this.cZu.project_id
      }
    };
    axios.get("api/project/import/hospitals", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.fanweiOptions = data.data;
      });
    });
  }
  /**
   * @description 删除一个医院范围
   */
  private deleteFanwei(index) {
    this.filter["范围"].splice(index, 1);
  }
  private clearFilters() {
    this.filter = {};
  }
  /**
   * @description 给所有message勾选上
   */
  private checkAllMessages(isChecked: boolean) {
    this.messages.forEach((message: any, index: number) => {
      this.$set(this.messages[index], "isChecked", isChecked);
    });
    this.isIndeterminate = false;
    this.checkAll = isChecked ? true : false;
  }
  /**
   * @description 增加一个数据到已选列表
   */
  private addOneMessageToSelectedMessages(message: any) {
    this.selectedMessages.push(message);
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 从已选列表中删除一条数据
   */
  private deleteOneMessageFromSelectedMessages(message: any) {
    const index = this.selectedMessages.findIndex(
      (selectedMessage: any) =>
        selectedMessage.patient_id === message.patient_id
    );
    if (index !== -1) {
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 增加当前页面所有的消息进入已选列表
   */
  private addAllMessagesToSelectedMessages() {
    this.messages.forEach((message: any) => {
      this.selectedMessages.push(message);
    });
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 将当前页面的所有数据，从已选列表中删除
   */
  private deleteAllMessagesFromSelectedMessages() {
    this.messages.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        this.selectedMessages.splice(targetIndex, 1);
      }
    });
  }
  /**
   * @description 统计当前页面有多少数据被选中
   */
  private countHowMuchCurrentPageMessagesSelected() {
    let checkedCount = 0;
    this.messages.forEach((message: any) => {
      if (message.isChecked) {
        checkedCount++;
      }
    });
    return checkedCount;
  }
  /**
   * @description 翻页后自动勾选上已经选择的数据
   */
  private autoCheckSelectedMessages(isChecked: boolean) {
    this.messages.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        message.isChecked = isChecked;
      }
    });
  }

  /**
   * @description 获得患者列表
   */
  private fetchPatients() {
    const hospitalIds: any[] = [];
    this.filter["范围"].forEach((item: any) => {
      hospitalIds.push(item.hospital_id);
    });
    const params: any = {
      params: {
        project_id: this.cZu.project_id,
        hospital_ids: JSON.stringify(hospitalIds),
        姓名: this.filter["姓名"],
        性别: this.filter["性别"],
        开始年龄: this.filter["开始年龄"],
        结束年龄: this.filter["结束年龄"],
        order_field: this.cSortField,
        order_value: this.cSortValue,
        current_page: this.currentPage,
        page_count: 10
      }
    };
    if (this.filter["time"]) {
      if (this.filter["time"][0]) {
        params.params["开始时间"] = this.filter["time"][0];
      }
      if (this.filter["time"][1]) {
        params.params["结束时间"] = this.filter["time"][1];
      }
    }
    axios.get("api/project/import/hospatients", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.messages = data.data.patients;
        this.totalPage = data.data.total_page;
        this.totalNum = data.data.total_count;
        if (this.saveModel === "add") {
          this.checkAllMessages(false);
          this.autoCheckSelectedMessages(true);
        } else {
          this.checkAllMessages(true);
          this.autoCheckSelectedMessages(false);
        }
        const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
        this.checkAll = checkedCount === this.messages.length;
        this.isIndeterminate =
          checkedCount > 0 && checkedCount < this.messages.length;
      });
    });
  }
  /**
   * @description 快速查找
   */
  private search() {
    this.currentPage = 1;
    this.saveModel = "delete";
    this.fetchPatients();
  }
  /**
   * @description 处理点击全选
   */
  private handleCheckAllChange(val) {
    if (val) {
      this.checkAllMessages(true);
      if (this.saveModel === "add") {
        this.addAllMessagesToSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.deleteAllMessagesFromSelectedMessages();
      }
    } else {
      this.checkAllMessages(false);
      if (this.saveModel === "add") {
        this.deleteAllMessagesFromSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.addAllMessagesToSelectedMessages();
      }
    }
  }
  /**
   * @description 处理单个勾选
   */
  private handleCheckedMessageChange(val, item) {
    if (val) {
      if (this.saveModel === "add") {
        this.addOneMessageToSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.deleteOneMessageFromSelectedMessages(item);
      }
    } else {
      if (this.saveModel === "add") {
        this.deleteOneMessageFromSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.addOneMessageToSelectedMessages(item);
      }
    }
    const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
    this.checkAll = checkedCount === this.messages.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.messages.length;
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    console.log(ev);
    this.cSortField = ev["prop"];
    this.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.fetchPatients();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.fetchPatients();
  }
  /**
   * @description 保存并导入
   */
  private save() {
    const idList: any[] = [];
    this.selectedMessages.forEach((message: any) => {
      idList.push(message.hpt_id);
    });
    const params: any = {
      project_id: this.cZu.project_id,
      group_id: this.cZu.group_id
    };
    if (this.saveModel === "add") {
      if (idList.length > 0) {
        params["hpt_ids"] = idList;
      } else {
        this.$message.error("请至少选择一条数据");
        return;
      }
      params["is_use_filter"] = false;
    } else if (this.saveModel === "delete") {
      params["is_use_filter"] = true;
      if (idList.length > 0) {
        params["del_hpt_ids"] = idList;
      }
      const hospitalIds: any[] = [];
      this.filter["范围"].forEach((item: any) => {
        hospitalIds.push(item.hospital_id);
      });
      params["filters"] = {
        hospital_ids: hospitalIds,
        姓名: this.filter["姓名"],
        性别: this.filter["性别"],
        开始年龄: this.filter["开始年龄"],
        结束年龄: this.filter["结束年龄"]
      };
      if (this.filter["time"]) {
        if (this.filter["time"][0]) {
          params["开始时间"] = this.filter["time"][0];
        }
        if (this.filter["time"][1]) {
          params["结束时间"] = this.filter["time"][1];
        }
      }
    }
    const loading = this.$loading({
      text: "加载中..."
    });
    axios.post("api/project/import/hospatients", params).then(({ data }) => {
      resHandle(this, data)
        .then(() => {
          this.$message.success("导入成功");
          loading.close();
          this.$emit("cStateChange", "normal");
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  /**
   * @description 测试
   */
  private test(item?) {
    console.log(this.selectedMessages);
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchPatients();
    this.getFanwei();
  }
}
